import "../App.scss";
import "./NewPatient.scss";
const TermsAndConditions = () => {
  return (
    <div className="pageContainer">
      <div className="pageHeader">
        <div className="h1 hippiBlue" style={{ marginBottom: "0.5rem" }}>
          Terms and Conditions
        </div>
        <div className="b1 midGray">
          These Terms and Conditions (“Terms”) govern your use of the Vetta
          Solutions application and services (“the Application”), operated by
          Vetta Solutions Inc., a C-Corporation registered in North Carolina,
          United States (“we,” “us,” or “our”). By accessing or using the
          Application, you agree to be bound by these Terms. If you disagree
          with any part, you may not access or use the Application.
        </div>
        <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
          1. Use of the Application
        </div>
        <div className="b1 midGray">
          You must be at least 18 years old to use this Application. By using
          it, you warrant that you meet this requirement. You agree not to:{" "}
          <ul>
            <li>Use the Application for unlawful purposes.</li>
            <li>
              Attempt to reverse engineer, copy, or exploit any part of the
              Application.
            </li>
            <li>
              {" "}
              Interfere with the functionality, security, or integrity of the
              Application or its services.
            </li>
          </ul>
        </div>
        <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
          2. User Accounts
        </div>
        <div className="b1 midGray">
          To access certain features, you may be required to register and
          provide personal information. You are responsible for maintaining the
          confidentiality of your account and password and for all activities
          that occur under your account.
        </div>
        <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
          3. Intellectual Property
        </div>
        <div className="b1 midGray">
          All content and features within the Application, including text,
          graphics, code, and software, are the intellectual property of Vetta
          Solutions Inc. and are protected by applicable intellectual property
          laws.
        </div>
        <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
          4. Disclaimer of Warranties
        </div>
        <div className="b1 midGray">
          The Application is provided on an “as is” and “as available” basis. We
          make no warranties or representations regarding the accuracy,
          reliability, or completeness of the content or services provided.
        </div>
        <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
          5. Limitation of Liability
        </div>
        <div className="b1 midGray">
          To the fullest extent permitted by law, Vetta Solutions Inc. shall not
          be liable for any direct, indirect, incidental, special, or
          consequential damages resulting from your use of or inability to use
          the Application.
        </div>
        <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
          6. Governing Law and Jurisdiction
        </div>
        <div className="b1 midGray">
          These Terms are governed by the laws of the United States and the
          State of North Carolina. Any disputes shall be resolved exclusively in
          the courts of Durham County, North Carolina.
        </div>
        <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
          7. Modifications to Terms
        </div>
        <div className="b1 midGray">
          We reserve the right to modify these Terms at any time. Changes will
          be effective immediately upon posting. Continued use of the
          Application constitutes acceptance of the revised Terms.
        </div>
        <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
          8. Contact
        </div>
        <div className="b1 midGray">
          For any questions about these Terms, please contact: <br />
          <b>Vetta Solutions Inc.</b>
          <br /> 6409 Fayetteville Road, Suite 120-173
          <br /> Durham, NC 27713
          <b>
            <br /> Email:
            <a href="mailto:contact@vettasolutions.com">
              contact@vettasolutions.com
            </a>
          </b>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
